import * as defaultImport from "@splunk/datasources/TestDataSource";
export * from "@splunk/datasources/TestDataSource";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
